export default __webpack_public_path__ + "static/media/mocambique.17ae6ce3.jpg";